import { mensagemDeErro } from '@alternativamais/chat-core';
import { createPortal } from 'react-dom';
import { create } from 'zustand';

import { Icone } from './Icone';

type Aviso = { id: number; texto: string; tipo: 'erro' | 'info' };

const useAvisos = create<{ avisos: Aviso[] }>(() => ({ avisos: [] }));
let proximo = 1;

/** Aviso rápido no pé da tela (some sozinho em 5 s). */
export function avisar(texto: string, tipo: Aviso['tipo'] = 'erro') {
  const id = proximo++;
  useAvisos.setState((estado) => ({
    avisos: [...estado.avisos.slice(-2), { id, texto, tipo }],
  }));
  window.setTimeout(() => fecharAviso(id), 5_000);
}

function fecharAviso(id: number) {
  useAvisos.setState((estado) => ({
    avisos: estado.avisos.filter((aviso) => aviso.id !== id),
  }));
}

export { mensagemDeErro };

export function avisarErro(erro: unknown) {
  avisar(mensagemDeErro(erro));
}

export function Avisos() {
  const avisos = useAvisos((estado) => estado.avisos);
  if (!avisos.length) return null;
  return createPortal(
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 bottom-24 z-[60] flex flex-col items-center gap-2 px-4"
    >
      {avisos.map((aviso) => (
        <div
          key={aviso.id}
          className="pointer-events-auto flex max-w-[480px] items-start gap-2.5 rounded-[10px] border border-borda bg-elevado py-3 pr-2 pl-3.5 text-sm shadow-[0_12px_32px_rgba(0,0,0,.45)]"
        >
          <Icone
            nome={aviso.tipo === 'erro' ? 'alerta' : 'info'}
            tamanho={18}
            className={aviso.tipo === 'erro' ? 'text-ocupado' : 'text-link'}
          />
          <p className="m-0 grow leading-normal">{aviso.texto}</p>
          <button
            type="button"
            aria-label="Fechar aviso"
            onClick={() => fecharAviso(aviso.id)}
            className="flex size-6 shrink-0 items-center justify-center rounded-md text-texto-3 hover:text-texto"
          >
            <Icone nome="x" tamanho={16} />
          </button>
        </div>
      ))}
    </div>,
    document.body,
  );
}
